module.exports = __webpack_public_path__ + "img/5_80.8cdfd66c.png";